import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout';
import LoadingScreen from '@/components/common/LoadingScreen';
import { ROUTES } from './paths';

// Every page is its own code-split chunk.
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const CatalogPage = lazy(() => import('@/pages/catalog/CatalogPage'));
const LibraryPage = lazy(() => import('@/pages/library/LibraryPage'));
const DocumentsListPage = lazy(() => import('@/pages/documents/DocumentsListPage'));
const DocumentDetailPage = lazy(() => import('@/pages/documents/DocumentDetailPage'));
const TopicDetailPage = lazy(() => import('@/pages/topics/TopicDetailPage'));
const ParagraphDetailPage = lazy(() => import('@/pages/paragraphs/ParagraphDetailPage'));
const CostsPage = lazy(() => import('@/pages/costs/CostsPage'));
const SystemHealthPage = lazy(() => import('@/pages/system/SystemHealthPage'));
const SettingsPage = lazy(() => import('@/pages/settings/SettingsPage'));
const NotFoundPage = lazy(() => import('@/pages/error/NotFoundPage'));

export default function AppRoutes() {
  return (
    <Suspense fallback={<LoadingScreen height="100vh" />}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
          <Route path={ROUTES.CATALOG} element={<CatalogPage />} />
          <Route path={ROUTES.LIBRARY} element={<LibraryPage />} />
          <Route path={ROUTES.DOCUMENTS} element={<DocumentsListPage />} />
          <Route path={ROUTES.DOCUMENT_DETAIL()} element={<DocumentDetailPage />} />
          <Route path={ROUTES.TOPIC_DETAIL()} element={<TopicDetailPage />} />
          <Route path={ROUTES.PARAGRAPH_DETAIL()} element={<ParagraphDetailPage />} />
          <Route path={ROUTES.COSTS} element={<CostsPage />} />
          <Route path={ROUTES.SYSTEM} element={<SystemHealthPage />} />
          <Route path={ROUTES.SETTINGS} element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
